export default __webpack_public_path__ + "static/media/logo.9752ac80.png";